export default __webpack_public_path__ + "static/media/photo--lg--kate-2.ed8107b5.jpg";